import initialState from "./initialState";

export function ServiceOrderQueryCriteriaReducer(
  state = initialState.serviceOrderQueryCriteriaParams,
  action
) {
  switch (action.type) {
    case "SERVICE_ORDER_QUERY_CRITERIA_REQUEST":
      return action.payload;

    default:
      return state;
  }
}
